import { of } from "rxjs";

export const NULL_OBSERVABLE = of(null);

export const nonFalsyPayload = <T extends {}>(payload: T) =>
  Object.entries(payload).reduce((acc: { [key: string]: any }, [k, v]) => {
    if (!!v) {
      acc[k] = v;
    }
    return acc;
  }, <T>{});

export const nullifyFalsyValues = <T extends {}>(payload: T): T => {
  const isFalsy = (value: unknown): boolean => {
    return value === undefined || value === null || value === 0 || value === "";
  };

  const isPlainObject = (value: unknown): value is Record<string, unknown> => {
    return value !== null && typeof value === "object" && value.constructor === Object;
  };

  const processObject = (obj: unknown): unknown => {
    if (obj === null || typeof obj !== "object" || !obj.constructor || obj.constructor !== Object) {
      return obj;
    }

    return Object.entries(obj).reduce((acc: { [key: string]: unknown }, [k, v]) => {
      if (isFalsy(v)) {
        acc[k] = null;
        return acc;
      }

      // Handle arrays - process each object element at first level only
      if (Array.isArray(v)) {
        acc[k] = v.map((item) => {
          return isPlainObject(item) ? processObject(item) : item;
        });
        return acc;
      }

      if (isPlainObject(v)) {
        acc[k] = processObject(v);
        return acc;
      }

      acc[k] = v;
      return acc;
    }, {});
  };

  return processObject(payload) as T;
};
